import { __extends } from "tslib";
import { ClickableOption } from "@shop-builder/shared/ClickableOption";
var KissDeviceDetailCapacity = /*@__PURE__*/ (function (_super) {
    __extends(KissDeviceDetailCapacity, _super);
    function KissDeviceDetailCapacity(value, label, callback, unit) {
        var _this = _super.call(this, value, label, callback, unit) || this;
        _this.capacityPlaceholder = "{CAPACITY}";
        _this.standardStyleClass = "mod-ep-kiss-device-detail__capacity-choice ";
        _this.activeStyleClass =
            "mod-ep-kiss-device-detail__capacity-choice--active";
        _this.disabledStyleClass =
            "mod-ep-kiss-device-detail__capacity-choice--inactive";
        _this.template =
            '<div class="mod-ep-kiss-device-detail__capacity-choice" ><div>' +
                _this.capacityPlaceholder +
                "</div></div>";
        _this.template = _this.template.replace(_this.capacityPlaceholder, _this.getLabel());
        _this.setUp();
        return _this;
    }
    return KissDeviceDetailCapacity;
}(ClickableOption));
export { KissDeviceDetailCapacity };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/shop-builder/widgets/kiss-device-detail/kiss-device-detail-capacity.ts
// module id = null
// module chunks = 